import { Role } from "@source/utils/models/adminModels";

export enum HomePermissionsEnum {
  ADD_NEW_RESIDENT = "add_new_resident",
  EDIT_RESIDENT = "edit_resident",
  VIEW_RESIDENTS = "view_residents",
  DISABLE_RESIDENT = 'disable_resident',
  ENABLE_RESIDENT = 'enable_resident',
  ADD_UPDATE = "add_update",
  VIEW_UPDATES = "view_updates",
  ADD_NEW_ANNOUNCEMENT_EVENT = "add_new_announcement_event",
  VIEW_ANNOUNCEMENT_EVENT = "view_announcement_event",
  EDIT_ANNOUNCEMENT_EVENT = "edit_announcement_event",
  VIEW_DISABLED_RESIDENT = "view_disabled_resident",
  DELETE_FAMILY_RELATION = "delete_family_relation",
  VIEW_HOME_STATISTIC = 'view_home_statistic',
  DOWNLOAD_UPDATE_HISTORY = 'download_update_history',
  DOWNLOAD_UNREAD_UPDATES = 'download_unread_updates',
  ADD_MULTIPLE_UPDATE = 'add_multiple_update',
  ADD_COMMENT_TO_RELATION = 'add_comment_to_relation',
}

export enum OrganizationPermissionsEnum {
  ADD_NEW_HOUSE = "add_new_house",
  ADD_NEW_EMPLOYEE = "add_new_employee",
  // EDIT_EMPLOYEE_PERMISSION = "edit_employee_permissions",
  EDIT_EMPLOYEE_PASSWORD = "edit_employee_password",
  DISABLE_EMPLOYEE = "disable_employee",
  ENABLE_EMPLOYEE = "enable_employee",
  DISABLE_FAMILY_MEMBER = "disable_family_member",
  ENABLE_FAMILY_MEMBER = "enable_family_member",
  ADD_FAMILY_MEMBER = "add_family_member",
  EDIT_FAMILY_MEMBER = "edit_family_member",
  RESET_PASSWORD_FAMILY_MEMBER = "reset_family_member_password",
  MARK_RESIDENTS_AS_NON_PARTICIPANT = "mark_member_as_non_participant",
  RESEND_FAMILY_INVITATION = 'resend_family_invitation',
  RESEND_EMPLOYEE_INVITATION = 'resend_employee_invitation',
  VIEW_ACCESS_KEYS = "view_access_keys",
  CREATE_ACCESS_KEYS = "create_access_keys",
  UPDATE_ACCESS_KEYS = "update_access_keys",
  REGISTER_ROOT_AGENCY_ACCOUNT = 'register_root_agency_account',
  VIEW_ROOT_AGENCY_ACCOUNTS = 'view_agency_accounts',
  EDIT_EMPLOYEE_PHOTO = 'edit_employee_photo',
  VIEW_CONSENT_TEMPLATES = 'view_consent_templates',
  MANAGE_CONSENT_TEMPLATES = 'manage_consent_templates',
  MANAGE_CONSENT_CATEGORIES = 'manage_consent_categories',
  VIEW_CONSENT_DOCUMENTS = 'view_consent_documents',
  MANAGE_CONSENT_DOCUMENTS = 'manage_consent_documents',
  DOWNLOAD_CONSENT_REPORTS = 'download_consent_reports',
  WITHDRAW_CONSENT_DOCUMENTS = 'withdraw_consent_documents',
}

export const permissionName = {
  [OrganizationPermissionsEnum.ADD_NEW_HOUSE]: "Add new home",
  [OrganizationPermissionsEnum.ADD_NEW_EMPLOYEE]: "Add new employee",
  // [OrganizationPermissionsEnum.EDIT_EMPLOYEE_PERMISSION]: "Edit employee permissions",
  [HomePermissionsEnum.ADD_NEW_RESIDENT]: "Add new resident",
  [HomePermissionsEnum.EDIT_RESIDENT]: "Edit Resident",
  [OrganizationPermissionsEnum.ADD_FAMILY_MEMBER]: "Add family member",
  [OrganizationPermissionsEnum.EDIT_FAMILY_MEMBER]: "Edit family member",
  [OrganizationPermissionsEnum.MARK_RESIDENTS_AS_NON_PARTICIPANT]: "Mark family member as non-participant",
  [HomePermissionsEnum.VIEW_RESIDENTS]: "View residents",
  [HomePermissionsEnum.DISABLE_RESIDENT]: "Deactivate resident",
  [HomePermissionsEnum.ENABLE_RESIDENT]: "Activate resident",
  [HomePermissionsEnum.ADD_UPDATE]: "Add update",
  [HomePermissionsEnum.VIEW_UPDATES]: "View updates",
  [OrganizationPermissionsEnum.EDIT_EMPLOYEE_PASSWORD]: "Edit employee password",
  [HomePermissionsEnum.ADD_NEW_ANNOUNCEMENT_EVENT]: "Add new announcement event",
  [HomePermissionsEnum.VIEW_ANNOUNCEMENT_EVENT]: "View announcement event",
  [HomePermissionsEnum.EDIT_ANNOUNCEMENT_EVENT]: "Edit announcement event",
  [OrganizationPermissionsEnum.DISABLE_FAMILY_MEMBER]: "Deactivate family member",
  [OrganizationPermissionsEnum.DISABLE_EMPLOYEE]: "Deactivate employee",
  [OrganizationPermissionsEnum.ENABLE_FAMILY_MEMBER]: "Activate family member",
  [OrganizationPermissionsEnum.ENABLE_EMPLOYEE]: "Activate employee",
  [OrganizationPermissionsEnum.VIEW_ACCESS_KEYS]: "View IP key",
  [OrganizationPermissionsEnum.CREATE_ACCESS_KEYS]: "Create IP keys",
  [OrganizationPermissionsEnum.UPDATE_ACCESS_KEYS]: "Update IP keys",
  [HomePermissionsEnum.VIEW_DISABLED_RESIDENT]: "View archive",
  [HomePermissionsEnum.DELETE_FAMILY_RELATION]: "Delete family relation",
  [HomePermissionsEnum.VIEW_HOME_STATISTIC]: "Download reports",
  [HomePermissionsEnum.DOWNLOAD_UPDATE_HISTORY]: "Download update history",
  [HomePermissionsEnum.DOWNLOAD_UNREAD_UPDATES]: "Download unread update history",
  [OrganizationPermissionsEnum.REGISTER_ROOT_AGENCY_ACCOUNT]: "Register agency account",
  [OrganizationPermissionsEnum.VIEW_ROOT_AGENCY_ACCOUNTS]: "View agency accounts",
  [HomePermissionsEnum.ADD_MULTIPLE_UPDATE]: "Add multiple update",
  [OrganizationPermissionsEnum.RESEND_FAMILY_INVITATION]: 'Resend invitation to family member',
  [OrganizationPermissionsEnum.RESEND_EMPLOYEE_INVITATION]: 'Resend invitation to employee',
  [OrganizationPermissionsEnum.RESET_PASSWORD_FAMILY_MEMBER]: 'Reset password of family member',
  [HomePermissionsEnum.ADD_COMMENT_TO_RELATION]: 'Add/Delete family member note',
  [OrganizationPermissionsEnum.EDIT_EMPLOYEE_PHOTO]: 'Edit employee profile photo',
  [OrganizationPermissionsEnum.VIEW_CONSENT_TEMPLATES]: 'View consent templates',
  [OrganizationPermissionsEnum.MANAGE_CONSENT_TEMPLATES]: 'Manage consent templates',
  [OrganizationPermissionsEnum.MANAGE_CONSENT_CATEGORIES]: 'Manage consent categories',
  [OrganizationPermissionsEnum.VIEW_CONSENT_DOCUMENTS]: 'View consent documents',
  [OrganizationPermissionsEnum.MANAGE_CONSENT_DOCUMENTS]: 'Manage consent documents',
  [OrganizationPermissionsEnum.DOWNLOAD_CONSENT_REPORTS]: 'Download consent reports',
  [OrganizationPermissionsEnum.WITHDRAW_CONSENT_DOCUMENTS]: 'Withdraw consent documents',
};

export const rolePermissions = {
  [Role.ORGANIZATION_ADMIN]: {
    homePermissions: [
      HomePermissionsEnum.VIEW_RESIDENTS,
      HomePermissionsEnum.VIEW_UPDATES,
      HomePermissionsEnum.ADD_UPDATE,
      HomePermissionsEnum.VIEW_ANNOUNCEMENT_EVENT,
      HomePermissionsEnum.EDIT_ANNOUNCEMENT_EVENT,
      HomePermissionsEnum.ADD_NEW_ANNOUNCEMENT_EVENT,
      HomePermissionsEnum.DELETE_FAMILY_RELATION,
      HomePermissionsEnum.EDIT_RESIDENT,
      HomePermissionsEnum.ADD_NEW_RESIDENT,
      HomePermissionsEnum.DISABLE_RESIDENT,
      HomePermissionsEnum.VIEW_DISABLED_RESIDENT,
      HomePermissionsEnum.DOWNLOAD_UPDATE_HISTORY,
      HomePermissionsEnum.VIEW_HOME_STATISTIC,
      HomePermissionsEnum.ADD_MULTIPLE_UPDATE,
      HomePermissionsEnum.DOWNLOAD_UNREAD_UPDATES,
      HomePermissionsEnum.ADD_COMMENT_TO_RELATION,
    ],
    orgPermissions: [
      OrganizationPermissionsEnum.EDIT_EMPLOYEE_PHOTO,
      OrganizationPermissionsEnum.EDIT_FAMILY_MEMBER,
      OrganizationPermissionsEnum.ADD_FAMILY_MEMBER,
      OrganizationPermissionsEnum.ENABLE_FAMILY_MEMBER,
      OrganizationPermissionsEnum.DISABLE_FAMILY_MEMBER,
      OrganizationPermissionsEnum.ADD_NEW_EMPLOYEE,
      OrganizationPermissionsEnum.ENABLE_EMPLOYEE,
      OrganizationPermissionsEnum.EDIT_EMPLOYEE_PASSWORD,
      OrganizationPermissionsEnum.DISABLE_EMPLOYEE,
      OrganizationPermissionsEnum.ADD_NEW_HOUSE,
      OrganizationPermissionsEnum.VIEW_ACCESS_KEYS,
      OrganizationPermissionsEnum.CREATE_ACCESS_KEYS,
      OrganizationPermissionsEnum.UPDATE_ACCESS_KEYS,
      OrganizationPermissionsEnum.VIEW_ROOT_AGENCY_ACCOUNTS,
      OrganizationPermissionsEnum.REGISTER_ROOT_AGENCY_ACCOUNT,
      OrganizationPermissionsEnum.RESEND_FAMILY_INVITATION,
      OrganizationPermissionsEnum.RESEND_EMPLOYEE_INVITATION,
      OrganizationPermissionsEnum.MARK_RESIDENTS_AS_NON_PARTICIPANT,
      OrganizationPermissionsEnum.VIEW_CONSENT_TEMPLATES,
      OrganizationPermissionsEnum.MANAGE_CONSENT_TEMPLATES,
      OrganizationPermissionsEnum.MANAGE_CONSENT_CATEGORIES,
      OrganizationPermissionsEnum.VIEW_CONSENT_DOCUMENTS,
      OrganizationPermissionsEnum.MANAGE_CONSENT_DOCUMENTS,
      OrganizationPermissionsEnum.DOWNLOAD_CONSENT_REPORTS,
      OrganizationPermissionsEnum.WITHDRAW_CONSENT_DOCUMENTS,
    ],
  },
  [Role.HOME_ADMIN]: {
    homePermissions: [
      HomePermissionsEnum.VIEW_RESIDENTS,
      HomePermissionsEnum.VIEW_UPDATES,
      HomePermissionsEnum.ADD_UPDATE,
      HomePermissionsEnum.VIEW_ANNOUNCEMENT_EVENT,
      HomePermissionsEnum.EDIT_ANNOUNCEMENT_EVENT,
      HomePermissionsEnum.ADD_NEW_ANNOUNCEMENT_EVENT,
      HomePermissionsEnum.DELETE_FAMILY_RELATION,
      HomePermissionsEnum.EDIT_RESIDENT,
      HomePermissionsEnum.ADD_NEW_RESIDENT,
      HomePermissionsEnum.DISABLE_RESIDENT,
      HomePermissionsEnum.VIEW_DISABLED_RESIDENT,
      HomePermissionsEnum.DOWNLOAD_UPDATE_HISTORY,
      HomePermissionsEnum.VIEW_HOME_STATISTIC,
      HomePermissionsEnum.ADD_MULTIPLE_UPDATE,
      HomePermissionsEnum.ADD_COMMENT_TO_RELATION,
    ],
    orgPermissions: [
      OrganizationPermissionsEnum.EDIT_EMPLOYEE_PHOTO,
      OrganizationPermissionsEnum.EDIT_FAMILY_MEMBER,
      OrganizationPermissionsEnum.ADD_FAMILY_MEMBER,
      OrganizationPermissionsEnum.ENABLE_FAMILY_MEMBER,
      OrganizationPermissionsEnum.DISABLE_FAMILY_MEMBER,
      OrganizationPermissionsEnum.ADD_NEW_EMPLOYEE,
      OrganizationPermissionsEnum.ENABLE_EMPLOYEE,
      OrganizationPermissionsEnum.EDIT_EMPLOYEE_PASSWORD,
      OrganizationPermissionsEnum.DISABLE_EMPLOYEE,
      OrganizationPermissionsEnum.RESEND_FAMILY_INVITATION,
      OrganizationPermissionsEnum.RESEND_EMPLOYEE_INVITATION,
      OrganizationPermissionsEnum.MARK_RESIDENTS_AS_NON_PARTICIPANT,
    ],
  },
  [Role.STAFF_ADMIN]: {
    homePermissions: [
      HomePermissionsEnum.ADD_NEW_RESIDENT,
      HomePermissionsEnum.EDIT_RESIDENT,
      HomePermissionsEnum.VIEW_RESIDENTS,
      HomePermissionsEnum.VIEW_ANNOUNCEMENT_EVENT,
      HomePermissionsEnum.ADD_UPDATE,
      HomePermissionsEnum.VIEW_UPDATES,
      HomePermissionsEnum.DOWNLOAD_UPDATE_HISTORY,
    ],
    orgPermissions: [
      OrganizationPermissionsEnum.ADD_NEW_EMPLOYEE,
      OrganizationPermissionsEnum.EDIT_EMPLOYEE_PASSWORD,
      OrganizationPermissionsEnum.DISABLE_EMPLOYEE,
      OrganizationPermissionsEnum.ENABLE_EMPLOYEE,
      OrganizationPermissionsEnum.ADD_FAMILY_MEMBER,
      OrganizationPermissionsEnum.EDIT_FAMILY_MEMBER,
      OrganizationPermissionsEnum.RESEND_FAMILY_INVITATION,
      OrganizationPermissionsEnum.VIEW_CONSENT_TEMPLATES,
      OrganizationPermissionsEnum.VIEW_CONSENT_DOCUMENTS,
      OrganizationPermissionsEnum.MANAGE_CONSENT_DOCUMENTS,
    ],
  },
  [Role.FAMILY_ADMIN]: {
    homePermissions: [
      HomePermissionsEnum.VIEW_RESIDENTS,
      HomePermissionsEnum.VIEW_UPDATES,
      HomePermissionsEnum.ADD_UPDATE,
      HomePermissionsEnum.VIEW_ANNOUNCEMENT_EVENT,
      HomePermissionsEnum.DELETE_FAMILY_RELATION,
      HomePermissionsEnum.EDIT_ANNOUNCEMENT_EVENT,
      HomePermissionsEnum.ADD_NEW_ANNOUNCEMENT_EVENT,
      HomePermissionsEnum.EDIT_RESIDENT,
      HomePermissionsEnum.ADD_NEW_RESIDENT,
      HomePermissionsEnum.ADD_COMMENT_TO_RELATION,
    ],
    orgPermissions: [
      OrganizationPermissionsEnum.EDIT_EMPLOYEE_PHOTO,
      OrganizationPermissionsEnum.EDIT_FAMILY_MEMBER,
      OrganizationPermissionsEnum.ADD_FAMILY_MEMBER,
      OrganizationPermissionsEnum.ENABLE_FAMILY_MEMBER,
      OrganizationPermissionsEnum.DISABLE_FAMILY_MEMBER,
      OrganizationPermissionsEnum.RESEND_FAMILY_INVITATION,
      OrganizationPermissionsEnum.MARK_RESIDENTS_AS_NON_PARTICIPANT,
    ],
  },
  [Role.NURSE]: {
    homePermissions: [
      HomePermissionsEnum.VIEW_RESIDENTS,
      HomePermissionsEnum.VIEW_UPDATES,
      HomePermissionsEnum.ADD_UPDATE,
      HomePermissionsEnum.VIEW_ANNOUNCEMENT_EVENT,
      HomePermissionsEnum.ADD_COMMENT_TO_RELATION,
    ],
    orgPermissions: [
      OrganizationPermissionsEnum.VIEW_CONSENT_DOCUMENTS,
      OrganizationPermissionsEnum.MANAGE_CONSENT_DOCUMENTS,
    ],
  },
  [Role.LIFESTYLE]: {
    homePermissions: [
      HomePermissionsEnum.VIEW_RESIDENTS,
      HomePermissionsEnum.VIEW_UPDATES,
      HomePermissionsEnum.ADD_UPDATE,
      HomePermissionsEnum.ADD_MULTIPLE_UPDATE,
      HomePermissionsEnum.ADD_NEW_ANNOUNCEMENT_EVENT,
      HomePermissionsEnum.EDIT_ANNOUNCEMENT_EVENT,
      HomePermissionsEnum.VIEW_ANNOUNCEMENT_EVENT,
      HomePermissionsEnum.ADD_COMMENT_TO_RELATION,
    ],
    orgPermissions: [],
  },
  [Role.CLINICAL_NURSE]: {
    homePermissions: [
      HomePermissionsEnum.VIEW_RESIDENTS,
      HomePermissionsEnum.VIEW_UPDATES,
      HomePermissionsEnum.ADD_UPDATE,
      HomePermissionsEnum.ADD_MULTIPLE_UPDATE,
      HomePermissionsEnum.ADD_NEW_ANNOUNCEMENT_EVENT,
      HomePermissionsEnum.EDIT_ANNOUNCEMENT_EVENT,
      HomePermissionsEnum.VIEW_ANNOUNCEMENT_EVENT,
      HomePermissionsEnum.ADD_COMMENT_TO_RELATION,
      HomePermissionsEnum.DOWNLOAD_UPDATE_HISTORY,
      HomePermissionsEnum.VIEW_HOME_STATISTIC,
    ],
    orgPermissions: [
      OrganizationPermissionsEnum.VIEW_CONSENT_TEMPLATES,
      OrganizationPermissionsEnum.VIEW_CONSENT_DOCUMENTS,
      OrganizationPermissionsEnum.MANAGE_CONSENT_DOCUMENTS,
    ],
  },
};

export const eCaseRolePermissions = {
  [Role.ORGANIZATION_ADMIN]: {
    homePermissions: [
      HomePermissionsEnum.VIEW_RESIDENTS,
      HomePermissionsEnum.VIEW_UPDATES,
      HomePermissionsEnum.ADD_UPDATE,
      HomePermissionsEnum.VIEW_ANNOUNCEMENT_EVENT,
      HomePermissionsEnum.EDIT_ANNOUNCEMENT_EVENT,
      HomePermissionsEnum.ADD_NEW_ANNOUNCEMENT_EVENT,
      HomePermissionsEnum.VIEW_DISABLED_RESIDENT,
      HomePermissionsEnum.DOWNLOAD_UPDATE_HISTORY,
      HomePermissionsEnum.VIEW_HOME_STATISTIC,
      HomePermissionsEnum.ADD_MULTIPLE_UPDATE,
      HomePermissionsEnum.DOWNLOAD_UNREAD_UPDATES,
    ],
    orgPermissions: [
      OrganizationPermissionsEnum.EDIT_EMPLOYEE_PHOTO,
      OrganizationPermissionsEnum.ADD_NEW_EMPLOYEE,
      OrganizationPermissionsEnum.ENABLE_EMPLOYEE,
      OrganizationPermissionsEnum.EDIT_EMPLOYEE_PASSWORD,
      OrganizationPermissionsEnum.DISABLE_EMPLOYEE,
      OrganizationPermissionsEnum.ADD_NEW_HOUSE,
      OrganizationPermissionsEnum.VIEW_ACCESS_KEYS,
      OrganizationPermissionsEnum.CREATE_ACCESS_KEYS,
      OrganizationPermissionsEnum.UPDATE_ACCESS_KEYS,
      OrganizationPermissionsEnum.VIEW_ROOT_AGENCY_ACCOUNTS,
      OrganizationPermissionsEnum.REGISTER_ROOT_AGENCY_ACCOUNT,
      OrganizationPermissionsEnum.RESEND_FAMILY_INVITATION,
      OrganizationPermissionsEnum.RESEND_EMPLOYEE_INVITATION,
      OrganizationPermissionsEnum.MARK_RESIDENTS_AS_NON_PARTICIPANT,
      OrganizationPermissionsEnum.VIEW_CONSENT_TEMPLATES,
      OrganizationPermissionsEnum.MANAGE_CONSENT_TEMPLATES,
      OrganizationPermissionsEnum.MANAGE_CONSENT_CATEGORIES,
      OrganizationPermissionsEnum.VIEW_CONSENT_DOCUMENTS,
      OrganizationPermissionsEnum.MANAGE_CONSENT_DOCUMENTS,
      OrganizationPermissionsEnum.DOWNLOAD_CONSENT_REPORTS,
      OrganizationPermissionsEnum.WITHDRAW_CONSENT_DOCUMENTS,
    ],
  },
  [Role.HOME_ADMIN]: {
    homePermissions: [
      HomePermissionsEnum.VIEW_RESIDENTS,
      HomePermissionsEnum.VIEW_UPDATES,
      HomePermissionsEnum.ADD_UPDATE,
      HomePermissionsEnum.VIEW_ANNOUNCEMENT_EVENT,
      HomePermissionsEnum.EDIT_ANNOUNCEMENT_EVENT,
      HomePermissionsEnum.ADD_NEW_ANNOUNCEMENT_EVENT,
      HomePermissionsEnum.VIEW_DISABLED_RESIDENT,
      HomePermissionsEnum.DOWNLOAD_UPDATE_HISTORY,
      HomePermissionsEnum.VIEW_HOME_STATISTIC,
      HomePermissionsEnum.ADD_MULTIPLE_UPDATE,
    ],
    orgPermissions: [
      OrganizationPermissionsEnum.EDIT_EMPLOYEE_PHOTO,
      OrganizationPermissionsEnum.ADD_NEW_EMPLOYEE,
      OrganizationPermissionsEnum.ENABLE_EMPLOYEE,
      OrganizationPermissionsEnum.EDIT_EMPLOYEE_PASSWORD,
      OrganizationPermissionsEnum.DISABLE_EMPLOYEE,
      OrganizationPermissionsEnum.RESEND_FAMILY_INVITATION,
      OrganizationPermissionsEnum.RESEND_EMPLOYEE_INVITATION,
      OrganizationPermissionsEnum.MARK_RESIDENTS_AS_NON_PARTICIPANT,
    ],
  },
  [Role.STAFF_ADMIN]: {
    homePermissions: [
      HomePermissionsEnum.VIEW_RESIDENTS,
      HomePermissionsEnum.VIEW_ANNOUNCEMENT_EVENT,
      HomePermissionsEnum.ADD_UPDATE,
      HomePermissionsEnum.VIEW_UPDATES,
      HomePermissionsEnum.DOWNLOAD_UPDATE_HISTORY,
    ],
    orgPermissions: [
      OrganizationPermissionsEnum.ADD_NEW_EMPLOYEE,
      OrganizationPermissionsEnum.EDIT_EMPLOYEE_PASSWORD,
      OrganizationPermissionsEnum.DISABLE_EMPLOYEE,
      OrganizationPermissionsEnum.ENABLE_EMPLOYEE,
      OrganizationPermissionsEnum.RESEND_FAMILY_INVITATION,
      OrganizationPermissionsEnum.VIEW_CONSENT_TEMPLATES,
      OrganizationPermissionsEnum.VIEW_CONSENT_DOCUMENTS,
      OrganizationPermissionsEnum.MANAGE_CONSENT_DOCUMENTS,
    ],
  },
  [Role.FAMILY_ADMIN]: {
    homePermissions: [
      HomePermissionsEnum.VIEW_RESIDENTS,
      HomePermissionsEnum.VIEW_UPDATES,
      HomePermissionsEnum.ADD_UPDATE,
      HomePermissionsEnum.VIEW_ANNOUNCEMENT_EVENT,
      HomePermissionsEnum.EDIT_ANNOUNCEMENT_EVENT,
      HomePermissionsEnum.ADD_NEW_ANNOUNCEMENT_EVENT,
    ],
    orgPermissions: [
      OrganizationPermissionsEnum.EDIT_EMPLOYEE_PHOTO,
      OrganizationPermissionsEnum.RESEND_FAMILY_INVITATION,
      OrganizationPermissionsEnum.MARK_RESIDENTS_AS_NON_PARTICIPANT,
    ],
  },
  [Role.NURSE]: {
    homePermissions: [
      HomePermissionsEnum.VIEW_RESIDENTS,
      HomePermissionsEnum.VIEW_UPDATES,
      HomePermissionsEnum.ADD_UPDATE,
      HomePermissionsEnum.VIEW_ANNOUNCEMENT_EVENT,
    ],
    orgPermissions: [
      OrganizationPermissionsEnum.VIEW_CONSENT_DOCUMENTS,
      OrganizationPermissionsEnum.MANAGE_CONSENT_DOCUMENTS,
    ],
  },
  [Role.LIFESTYLE]: {
    homePermissions: [
      HomePermissionsEnum.VIEW_RESIDENTS,
      HomePermissionsEnum.VIEW_UPDATES,
      HomePermissionsEnum.ADD_UPDATE,
      HomePermissionsEnum.ADD_MULTIPLE_UPDATE,
      HomePermissionsEnum.ADD_NEW_ANNOUNCEMENT_EVENT,
      HomePermissionsEnum.EDIT_ANNOUNCEMENT_EVENT,
      HomePermissionsEnum.VIEW_ANNOUNCEMENT_EVENT,
    ],
    orgPermissions: [],
  },
  [Role.CLINICAL_NURSE]: {
    homePermissions: [
      HomePermissionsEnum.VIEW_RESIDENTS,
      HomePermissionsEnum.VIEW_UPDATES,
      HomePermissionsEnum.ADD_UPDATE,
      HomePermissionsEnum.ADD_MULTIPLE_UPDATE,
      HomePermissionsEnum.ADD_NEW_ANNOUNCEMENT_EVENT,
      HomePermissionsEnum.EDIT_ANNOUNCEMENT_EVENT,
      HomePermissionsEnum.VIEW_ANNOUNCEMENT_EVENT,
      HomePermissionsEnum.DOWNLOAD_UPDATE_HISTORY,
      HomePermissionsEnum.VIEW_HOME_STATISTIC,
    ],
    orgPermissions: [
      OrganizationPermissionsEnum.VIEW_CONSENT_TEMPLATES,
      OrganizationPermissionsEnum.VIEW_CONSENT_DOCUMENTS,
      OrganizationPermissionsEnum.MANAGE_CONSENT_DOCUMENTS,
    ],
  },
};

export const leeCareRolePermissions = {
  [Role.ORGANIZATION_ADMIN]: {
    homePermissions: [
      HomePermissionsEnum.VIEW_RESIDENTS,
      HomePermissionsEnum.VIEW_UPDATES,
      HomePermissionsEnum.ADD_UPDATE,
      HomePermissionsEnum.VIEW_ANNOUNCEMENT_EVENT,
      HomePermissionsEnum.EDIT_ANNOUNCEMENT_EVENT,
      HomePermissionsEnum.ADD_NEW_ANNOUNCEMENT_EVENT,
      HomePermissionsEnum.VIEW_DISABLED_RESIDENT,
      HomePermissionsEnum.DOWNLOAD_UPDATE_HISTORY,
      HomePermissionsEnum.VIEW_HOME_STATISTIC,
      HomePermissionsEnum.ADD_MULTIPLE_UPDATE,
      HomePermissionsEnum.DOWNLOAD_UNREAD_UPDATES,
      HomePermissionsEnum.ADD_COMMENT_TO_RELATION,
    ],
    orgPermissions: [
      OrganizationPermissionsEnum.EDIT_EMPLOYEE_PHOTO,
      OrganizationPermissionsEnum.ENABLE_EMPLOYEE,
      OrganizationPermissionsEnum.EDIT_EMPLOYEE_PASSWORD,
      OrganizationPermissionsEnum.DISABLE_EMPLOYEE,
      OrganizationPermissionsEnum.VIEW_ACCESS_KEYS,
      OrganizationPermissionsEnum.CREATE_ACCESS_KEYS,
      OrganizationPermissionsEnum.UPDATE_ACCESS_KEYS,
      OrganizationPermissionsEnum.VIEW_ROOT_AGENCY_ACCOUNTS,
      OrganizationPermissionsEnum.REGISTER_ROOT_AGENCY_ACCOUNT,
      OrganizationPermissionsEnum.RESEND_FAMILY_INVITATION,
      OrganizationPermissionsEnum.RESEND_EMPLOYEE_INVITATION,
      OrganizationPermissionsEnum.MARK_RESIDENTS_AS_NON_PARTICIPANT,
      OrganizationPermissionsEnum.VIEW_CONSENT_TEMPLATES,
      OrganizationPermissionsEnum.MANAGE_CONSENT_TEMPLATES,
      OrganizationPermissionsEnum.MANAGE_CONSENT_CATEGORIES,
      OrganizationPermissionsEnum.VIEW_CONSENT_DOCUMENTS,
      OrganizationPermissionsEnum.MANAGE_CONSENT_DOCUMENTS,
      OrganizationPermissionsEnum.DOWNLOAD_CONSENT_REPORTS,
      OrganizationPermissionsEnum.WITHDRAW_CONSENT_DOCUMENTS,
    ],
  },
  [Role.HOME_ADMIN]: {
    homePermissions: [
      HomePermissionsEnum.VIEW_RESIDENTS,
      HomePermissionsEnum.VIEW_UPDATES,
      HomePermissionsEnum.ADD_UPDATE,
      HomePermissionsEnum.VIEW_ANNOUNCEMENT_EVENT,
      HomePermissionsEnum.EDIT_ANNOUNCEMENT_EVENT,
      HomePermissionsEnum.ADD_NEW_ANNOUNCEMENT_EVENT,
      HomePermissionsEnum.VIEW_DISABLED_RESIDENT,
      HomePermissionsEnum.DOWNLOAD_UPDATE_HISTORY,
      HomePermissionsEnum.VIEW_HOME_STATISTIC,
      HomePermissionsEnum.ADD_MULTIPLE_UPDATE,
      HomePermissionsEnum.ADD_COMMENT_TO_RELATION,
    ],
    orgPermissions: [
      OrganizationPermissionsEnum.EDIT_EMPLOYEE_PHOTO,
      OrganizationPermissionsEnum.EDIT_FAMILY_MEMBER,
      OrganizationPermissionsEnum.ENABLE_EMPLOYEE,
      OrganizationPermissionsEnum.DISABLE_EMPLOYEE,
      OrganizationPermissionsEnum.RESEND_FAMILY_INVITATION,
      OrganizationPermissionsEnum.RESEND_EMPLOYEE_INVITATION,
      OrganizationPermissionsEnum.MARK_RESIDENTS_AS_NON_PARTICIPANT,
    ],
  },
  [Role.STAFF_ADMIN]: {
    homePermissions: [
      HomePermissionsEnum.VIEW_RESIDENTS,
      HomePermissionsEnum.VIEW_ANNOUNCEMENT_EVENT,
      HomePermissionsEnum.ADD_UPDATE,
      HomePermissionsEnum.VIEW_UPDATES,
      HomePermissionsEnum.DOWNLOAD_UPDATE_HISTORY,
    ],
    orgPermissions: [
      OrganizationPermissionsEnum.EDIT_EMPLOYEE_PASSWORD,
      OrganizationPermissionsEnum.DISABLE_EMPLOYEE,
      OrganizationPermissionsEnum.ENABLE_EMPLOYEE,
      OrganizationPermissionsEnum.RESEND_FAMILY_INVITATION,
      OrganizationPermissionsEnum.VIEW_CONSENT_TEMPLATES,
      OrganizationPermissionsEnum.VIEW_CONSENT_DOCUMENTS,
      OrganizationPermissionsEnum.MANAGE_CONSENT_DOCUMENTS,
    ],
  },
  [Role.FAMILY_ADMIN]: {
    homePermissions: [
      HomePermissionsEnum.VIEW_RESIDENTS,
      HomePermissionsEnum.VIEW_UPDATES,
      HomePermissionsEnum.ADD_UPDATE,
      HomePermissionsEnum.VIEW_ANNOUNCEMENT_EVENT,
      HomePermissionsEnum.EDIT_ANNOUNCEMENT_EVENT,
      HomePermissionsEnum.ADD_NEW_ANNOUNCEMENT_EVENT,
      HomePermissionsEnum.ADD_COMMENT_TO_RELATION,
    ],
    orgPermissions: [
      OrganizationPermissionsEnum.EDIT_EMPLOYEE_PHOTO,
      OrganizationPermissionsEnum.RESEND_FAMILY_INVITATION,
      OrganizationPermissionsEnum.MARK_RESIDENTS_AS_NON_PARTICIPANT,
    ],
  },
  [Role.NURSE]: {
    homePermissions: [
      HomePermissionsEnum.VIEW_RESIDENTS,
      HomePermissionsEnum.VIEW_UPDATES,
      HomePermissionsEnum.ADD_UPDATE,
      HomePermissionsEnum.VIEW_ANNOUNCEMENT_EVENT,
      HomePermissionsEnum.ADD_COMMENT_TO_RELATION,
    ],
    orgPermissions: [
      OrganizationPermissionsEnum.VIEW_CONSENT_DOCUMENTS,
      OrganizationPermissionsEnum.MANAGE_CONSENT_DOCUMENTS,
    ],
  },
  [Role.LIFESTYLE]: {
    homePermissions: [
      HomePermissionsEnum.VIEW_RESIDENTS,
      HomePermissionsEnum.VIEW_UPDATES,
      HomePermissionsEnum.ADD_UPDATE,
      HomePermissionsEnum.ADD_MULTIPLE_UPDATE,
      HomePermissionsEnum.ADD_NEW_ANNOUNCEMENT_EVENT,
      HomePermissionsEnum.EDIT_ANNOUNCEMENT_EVENT,
      HomePermissionsEnum.VIEW_ANNOUNCEMENT_EVENT,
      HomePermissionsEnum.ADD_COMMENT_TO_RELATION,
    ],
    orgPermissions: [],
  },
  [Role.CLINICAL_NURSE]: {
    homePermissions: [
      HomePermissionsEnum.VIEW_RESIDENTS,
      HomePermissionsEnum.VIEW_UPDATES,
      HomePermissionsEnum.ADD_UPDATE,
      HomePermissionsEnum.ADD_MULTIPLE_UPDATE,
      HomePermissionsEnum.ADD_NEW_ANNOUNCEMENT_EVENT,
      HomePermissionsEnum.EDIT_ANNOUNCEMENT_EVENT,
      HomePermissionsEnum.VIEW_ANNOUNCEMENT_EVENT,
      HomePermissionsEnum.ADD_COMMENT_TO_RELATION,
      HomePermissionsEnum.DOWNLOAD_UPDATE_HISTORY,
      HomePermissionsEnum.VIEW_HOME_STATISTIC,
    ],
    orgPermissions: [
      OrganizationPermissionsEnum.VIEW_CONSENT_TEMPLATES,
      OrganizationPermissionsEnum.VIEW_CONSENT_DOCUMENTS,
      OrganizationPermissionsEnum.MANAGE_CONSENT_DOCUMENTS,
    ],
  },
};

export const SSOLeeCareRolePermissions = {
  [Role.ORGANIZATION_ADMIN]: {
    homePermissions: [
      HomePermissionsEnum.VIEW_RESIDENTS,
      HomePermissionsEnum.VIEW_UPDATES,
      HomePermissionsEnum.ADD_UPDATE,
      HomePermissionsEnum.VIEW_ANNOUNCEMENT_EVENT,
      HomePermissionsEnum.EDIT_ANNOUNCEMENT_EVENT,
      HomePermissionsEnum.ADD_NEW_ANNOUNCEMENT_EVENT,
      HomePermissionsEnum.VIEW_DISABLED_RESIDENT,
      HomePermissionsEnum.DOWNLOAD_UPDATE_HISTORY,
      HomePermissionsEnum.VIEW_HOME_STATISTIC,
      HomePermissionsEnum.ADD_MULTIPLE_UPDATE,
      HomePermissionsEnum.DOWNLOAD_UNREAD_UPDATES,
      HomePermissionsEnum.ADD_COMMENT_TO_RELATION,
    ],
    orgPermissions: [
      OrganizationPermissionsEnum.EDIT_EMPLOYEE_PHOTO,
      OrganizationPermissionsEnum.VIEW_ACCESS_KEYS,
      OrganizationPermissionsEnum.CREATE_ACCESS_KEYS,
      OrganizationPermissionsEnum.UPDATE_ACCESS_KEYS,
      OrganizationPermissionsEnum.VIEW_ROOT_AGENCY_ACCOUNTS,
      OrganizationPermissionsEnum.REGISTER_ROOT_AGENCY_ACCOUNT,
      OrganizationPermissionsEnum.RESEND_FAMILY_INVITATION,
      OrganizationPermissionsEnum.MARK_RESIDENTS_AS_NON_PARTICIPANT,
      OrganizationPermissionsEnum.VIEW_CONSENT_TEMPLATES,
      OrganizationPermissionsEnum.MANAGE_CONSENT_TEMPLATES,
      OrganizationPermissionsEnum.MANAGE_CONSENT_CATEGORIES,
      OrganizationPermissionsEnum.VIEW_CONSENT_DOCUMENTS,
      OrganizationPermissionsEnum.MANAGE_CONSENT_DOCUMENTS,
      OrganizationPermissionsEnum.DOWNLOAD_CONSENT_REPORTS,
      OrganizationPermissionsEnum.WITHDRAW_CONSENT_DOCUMENTS,
    ],
  },
  [Role.HOME_ADMIN]: {
    homePermissions: [
      HomePermissionsEnum.VIEW_RESIDENTS,
      HomePermissionsEnum.VIEW_UPDATES,
      HomePermissionsEnum.ADD_UPDATE,
      HomePermissionsEnum.VIEW_ANNOUNCEMENT_EVENT,
      HomePermissionsEnum.EDIT_ANNOUNCEMENT_EVENT,
      HomePermissionsEnum.ADD_NEW_ANNOUNCEMENT_EVENT,
      HomePermissionsEnum.VIEW_DISABLED_RESIDENT,
      HomePermissionsEnum.DOWNLOAD_UPDATE_HISTORY,
      HomePermissionsEnum.VIEW_HOME_STATISTIC,
      HomePermissionsEnum.ADD_MULTIPLE_UPDATE,
      HomePermissionsEnum.ADD_COMMENT_TO_RELATION,
    ],
    orgPermissions: [
      OrganizationPermissionsEnum.EDIT_EMPLOYEE_PHOTO,
      OrganizationPermissionsEnum.EDIT_FAMILY_MEMBER,
      OrganizationPermissionsEnum.RESEND_FAMILY_INVITATION,
      OrganizationPermissionsEnum.MARK_RESIDENTS_AS_NON_PARTICIPANT,
    ],
  },
  [Role.STAFF_ADMIN]: {
    homePermissions: [
      HomePermissionsEnum.VIEW_RESIDENTS,
      HomePermissionsEnum.VIEW_ANNOUNCEMENT_EVENT,
      HomePermissionsEnum.ADD_UPDATE,
      HomePermissionsEnum.VIEW_UPDATES,
      HomePermissionsEnum.DOWNLOAD_UPDATE_HISTORY,
    ],
    orgPermissions: [
      OrganizationPermissionsEnum.RESEND_FAMILY_INVITATION,
      OrganizationPermissionsEnum.VIEW_CONSENT_TEMPLATES,
      OrganizationPermissionsEnum.VIEW_CONSENT_DOCUMENTS,
      OrganizationPermissionsEnum.MANAGE_CONSENT_DOCUMENTS,
    ],
  },
  [Role.FAMILY_ADMIN]: {
    homePermissions: [
      HomePermissionsEnum.VIEW_RESIDENTS,
      HomePermissionsEnum.VIEW_UPDATES,
      HomePermissionsEnum.ADD_UPDATE,
      HomePermissionsEnum.VIEW_ANNOUNCEMENT_EVENT,
      HomePermissionsEnum.EDIT_ANNOUNCEMENT_EVENT,
      HomePermissionsEnum.ADD_NEW_ANNOUNCEMENT_EVENT,
      HomePermissionsEnum.ADD_COMMENT_TO_RELATION,
    ],
    orgPermissions: [
      OrganizationPermissionsEnum.EDIT_EMPLOYEE_PHOTO,
      OrganizationPermissionsEnum.RESEND_FAMILY_INVITATION,
      OrganizationPermissionsEnum.MARK_RESIDENTS_AS_NON_PARTICIPANT,
    ],
  },
  [Role.NURSE]: {
    homePermissions: [
      HomePermissionsEnum.VIEW_RESIDENTS,
      HomePermissionsEnum.VIEW_UPDATES,
      HomePermissionsEnum.ADD_UPDATE,
      HomePermissionsEnum.VIEW_ANNOUNCEMENT_EVENT,
      HomePermissionsEnum.ADD_COMMENT_TO_RELATION,
    ],
    orgPermissions: [
      OrganizationPermissionsEnum.VIEW_CONSENT_DOCUMENTS,
      OrganizationPermissionsEnum.MANAGE_CONSENT_DOCUMENTS,
    ],
  },
  [Role.LIFESTYLE]: {
    homePermissions: [
      HomePermissionsEnum.VIEW_RESIDENTS,
      HomePermissionsEnum.VIEW_UPDATES,
      HomePermissionsEnum.ADD_UPDATE,
      HomePermissionsEnum.ADD_MULTIPLE_UPDATE,
      HomePermissionsEnum.ADD_NEW_ANNOUNCEMENT_EVENT,
      HomePermissionsEnum.EDIT_ANNOUNCEMENT_EVENT,
      HomePermissionsEnum.VIEW_ANNOUNCEMENT_EVENT,
      HomePermissionsEnum.ADD_COMMENT_TO_RELATION,
    ],
    orgPermissions: [],
  },
  [Role.CLINICAL_NURSE]: {
    homePermissions: [
      HomePermissionsEnum.VIEW_RESIDENTS,
      HomePermissionsEnum.VIEW_UPDATES,
      HomePermissionsEnum.ADD_UPDATE,
      HomePermissionsEnum.ADD_MULTIPLE_UPDATE,
      HomePermissionsEnum.ADD_NEW_ANNOUNCEMENT_EVENT,
      HomePermissionsEnum.EDIT_ANNOUNCEMENT_EVENT,
      HomePermissionsEnum.VIEW_ANNOUNCEMENT_EVENT,
      HomePermissionsEnum.ADD_COMMENT_TO_RELATION,
      HomePermissionsEnum.DOWNLOAD_UPDATE_HISTORY,
      HomePermissionsEnum.VIEW_HOME_STATISTIC,
    ],
    orgPermissions: [
      OrganizationPermissionsEnum.VIEW_CONSENT_TEMPLATES,
      OrganizationPermissionsEnum.VIEW_CONSENT_DOCUMENTS,
      OrganizationPermissionsEnum.MANAGE_CONSENT_DOCUMENTS,
    ],
  },
};